import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LogInPage from "../pages/LogInPage";
import PasswordResetPage from "../pages/PasswordResetPage";
import SignupPage from "../pages/SignupPage";
import AuthCallbackPage from "../pages/AuthCallbackPage"; // TODO: deprecate
import EBayOAuthCallbackPage from "src/pages/EBayOAuthCallbackPage";
import AmazonOAuthCallbackPage from "src/pages/AmazonOAuthCallbackPage";
import PrivateRouter from "./PrivateRouter";
import SupportRouter from "./SupportRouter";
import AccountantRouter from "./AccountantRouter";

import {
  authorizingSelector,
  isLoggedInSelector,
} from "../store/system/selector";
import { supportIsAccountant } from "../store/support/selector";
import AppLoader from "src/components/AppLoader";
import PlaidAuthCallbackPage from "../pages/PlaidAuthCallbackPage";
import { SafeZendesk as Zendesk } from "src/components/Zendesk";
import EtsyAuthCallbackPage from "../pages/EtsyAuthCallbackPage/EtsyAuthCallbackPage";
import ImpersonationRevocationToast from "src/components/ImpersonationRevocationToast";
import AppVersionBanner from "src/components/AppVersionBanner";
import GlobalErrorHandlers from "src/components/GlobalErrorHandlers";
import AppErrorBoundary from "src/components/AppErrorBoundary";
import MetaPixel from "src/components/MetaPixel";
import CookieConsent from "src/components/CookieConsent";

function RouterWrapper() {
  return (
    <>
      <GlobalErrorHandlers />
      <BrowserRouter>
        <ImpersonationRevocationToast />
        <AppErrorBoundary>
          <Switch>
            <Route path="/support" component={SupportRouter} />
            <Route path="/accountant" component={AccountantRouter} />
            <Route component={Router} />
          </Switch>
          <MetaPixel />
          <CookieConsent />
          <AppVersionBanner />
        </AppErrorBoundary>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export function Router() {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const authorizing = useSelector(authorizingSelector);
  const isAccountant = useSelector(supportIsAccountant);

  if (authorizing) return <AppLoader />;

  return (
    <>
      <Switch>
        <Route exact path="/login" component={LogInPage} />
        <Route exact path="/signup" component={SignupPage} />
        <Route exact path="/forgotpassword" component={PasswordResetPage} />
        <Route exact path="/auth/ebay/callback" component={AuthCallbackPage} />
        <Route
          exact
          path="/auth/etsy/callback"
          component={EtsyAuthCallbackPage}
        />
        <Route
          exact
          path="/oauth/ebay/callback"
          component={EBayOAuthCallbackPage}
        />
        <Route
          exact
          path="/auth/plaid/callback"
          component={PlaidAuthCallbackPage}
        />
        <Route
          exact
          path="/oauth/amazon/callback"
          component={AmazonOAuthCallbackPage}
        />
        {!authorizing && isLoggedIn && <PrivateRouter />}
        {!authorizing && !isLoggedIn && (
          <Redirect to={isAccountant ? "/accountant" : "/login"} />
        )}
      </Switch>
      <Zendesk isLoggedIn={isLoggedIn} />
    </>
  );
}

export default RouterWrapper;
